import type { ViewportTier } from "../../lib/viewport";
import { isCompactViewport, isMobileViewport } from "../../lib/viewport";

export type Vec3Tuple = [number, number, number];

export type AboutSceneLayout = {
  basePosition: Vec3Tuple;
  baseScale: number;
  stackPosition: Vec3Tuple;
  stackScale: number;
  titlePosition: Vec3Tuple;
  titleRotation: Vec3Tuple;
  titleFontSize: number;
  titleMaxWidth: number;
  floorPosition: Vec3Tuple;
  floorScale: Vec3Tuple;
};

export function getAboutSceneLayout(viewport: ViewportTier): AboutSceneLayout {
  if (isMobileViewport(viewport)) {
    return {
      basePosition: [0.36, -0.34, -2.12],
      baseScale: 1.02,
      stackPosition: [0.44, -0.22, 0],
      stackScale: 1.02,
      titlePosition: [0.42, 0.86, -0.16],
      titleRotation: [0.04, -0.2, -0.08],
      titleFontSize: 0.22,
      titleMaxWidth: 1.35,
      floorPosition: [0.44, -0.98, -0.2],
      floorScale: [1.15, 0.5, 1]
    };
  }

  if (isCompactViewport(viewport)) {
    return {
      basePosition: [1.6, -0.04, -2.08],
      baseScale: 1.16,
      stackPosition: [0.2, -0.15, 0],
      stackScale: 1.14,
      titlePosition: [0.25, 0.84, -0.18],
      titleRotation: [0.06, -0.24, -0.06],
      titleFontSize: 0.26,
      titleMaxWidth: 1.72,
      floorPosition: [0.2, -1.0, -0.24],
      floorScale: [1.52, 0.56, 1]
    };
  }

  return {
    basePosition: [2.05, -0.04, -2.02],
    baseScale: 1.36,
    stackPosition: [0.02, -0.2, 0],
    stackScale: 1.2,
    titlePosition: [0.18, 0.88, -0.22],
    titleRotation: [0.06, -1.1, -0.17],
    titleFontSize: 0.5,
    titleMaxWidth: 4.9,
    floorPosition: [0.02, -1.03, -0.25],
    floorScale: [1.8, 0.62, 1]
  };
}
